import { render, staticRenderFns } from "./ktpCamera.vue?vue&type=template&id=22ab9b4c&scoped=true"
import script from "./ktpCamera.vue?vue&type=script&lang=js"
export * from "./ktpCamera.vue?vue&type=script&lang=js"
import style0 from "./ktpCamera.vue?vue&type=style&index=0&id=22ab9b4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ab9b4c",
  null
  
)

export default component.exports